import styled from 'styled-components';

export const Background = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #000;
  color: #fff;
`;

export const GameControls = styled.div`
  width: 1280px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
`;

export const FullScreenButton = styled.button`
  width: 50px;
  height: 50px;
  background: #8601ab;
  color: #fff;
  border: 0;

  &:hover {
    background: #e949f7;
  }
`;

export const Socials = styled.div`
  a {
    margin-right: 5px;

    &:first-child:hover {
      svg {
        fill: #1da1f2;
      }
    }

    &:last-child:hover {
      svg {
        fill: #e1306c;
      }
    }
  }
`;
